import CartConfirmationDelivery from "../info/CartConfirmationDelivery";
import CartConfirmationHeader from "../info/CartConfirmationHeader";
import CartConfirmationLines from "../info/CartConfirmationLines";
import CartConfirmationPrint from "../info/CartConfirmationPrint";
import CartConfirmationSummary from "./CartConfirmationSummary";

const CartConfirmation = ({ completedOrder }) => {

    return (
        <div className="cart-container">
            <div className="cart-header">
                <p className="cart-h1">Order Confirmation</p>
            </div>

            <div className="cart-content">
                <div className="cart-section">
                    <CartConfirmationDelivery completedOrder={completedOrder} />
                </div>

                <div className="cart-full-width cart-section">
                    <CartConfirmationHeader completedOrder={completedOrder}/>
                </div>

                <div className="cart-full-width">
                    <p className="cart-h2">Lines</p>
                    <CartConfirmationLines completedOrder={completedOrder}/>
                </div>

                <div className="cart-column"/>
                <div className="cart-column">
                    <div className="cart-section">
                        <p className="cart-h2">Summary</p>
                        <CartConfirmationSummary completedOrder={completedOrder}/>
                    </div>
                    <div className="cart-section">
                        <p className="cart-h2">Print</p>
                        <CartConfirmationPrint completedOrder={completedOrder} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CartConfirmation;
